import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ToastProvider from '@/components/common/ToastProvider';
import { VoiceCallProvider } from '@/contexts/VoiceCallContext';
import { initSentry } from '@/services/sentry';
import './styles/tailwind.css';

// Initialize Sentry error tracking before rendering app
initSentry();

// Initialize base theme
try {
  document.documentElement.classList.add('dark');
  if (!localStorage.getItem('theme')) {
    localStorage.setItem('theme', 'dark');
  }
} catch (e) {}

// Debug: log React version at startup to detect multiple copies
try {
  console.info('[startup] React version:', (React as any).version);
} catch (e) {
  // ignore
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ToastProvider>
      <VoiceCallProvider>
        <App />
      </VoiceCallProvider>
    </ToastProvider>
  </React.StrictMode>,
);
